"use client";

import TimelineYear from "./TimelineYear";
import TimelineArticle from "./TimelineArticle";
import ContentCard from "./ContentCard";
import { useState, useMemo, useEffect } from "react";

const TimelineRoadmap = () => {
  const [selectedArticles, setSelectedArticles] = useState({});
  
  useEffect(() => {
    const initialSelected = {};
    timelineData.forEach((section, sectionIndex) => {
      const firstItemTitle = section.articles?.[0]?.listItems?.[0];
      const fullContent = allContentCards.find((card) => card.title === firstItemTitle);

      initialSelected[sectionIndex] = {
        title: firstItemTitle,
        listItems: fullContent ? fullContent.content : [firstItemTitle],
      };
    });
    setSelectedArticles(initialSelected);
  }, []);

  const timelineData = [
    {
      articles: [
        {
          date: "Feb 2025",
          subtitle: "Starting with our journey",
          image: {
            src: "https://ihkaas.io/wp-content/uploads/2025/01/Logo-600x300-2.png",
            width: 600,
            height: 300,
          },
          title: "Short-Term Goals (Year 1-2)",
          listItems: [
            "Presale & Market Entry",
            "IHKAAS Ecosystem Enhancements",
            "Business & Community Growth",
          ],
          iconColor: "text-red-600 border-red-600 decoration-red-600",
        },
      ],
    },
    {
      articles: [
        {
          date: "Jan 2027-2030",
          subtitle: "Medium-Term Goals (Year 3-5)",
          image: {
            src: "https://ihkaas.io/wp-content/uploads/2024/12/836e84a0-c8ff-4f4e-9be7-e2fe1cee5264.jpeg.webp",
            width: 224,
            height: 624,
          },
          title: "Medium-Term Goals (Year 3-5)",
          listItems: [
            "Advanced Exchange Listings",
            "Business & Token Adoption Growth",
            "Education & Community Growth",
          ],
          iconColor: "text-amber-400 border-amber-400 decoration-amber-400",
        },
      ],
    },
    {

      articles: [
        {
          date: "Jan 2030-2035",
          subtitle: "Long-Term Goals (Year 5-10) ",
          image: {
            src: "https://ihkaas.io/wp-content/uploads/2025/01/ecd73e10-6b87-4234-8704-9548f5ac4900.jpeg.webp",
            width: 154,
            height: 224,
          },
          title: "Long-Term Goals (Year 5-10) ",
          listItems: [
            "Year 5-7: Global Expansion & Mass Adoption",
            "Metaverse & AI-Driven Commerce",
            "Year 7-10: Sustained Ecosystem Development",
            "Decentralized Community Governance",
            "Physical Business Integration",
          ],
          iconColor: "text-green-500 border-green-500 decoration-green-500",
        },
      ],
    },
    {

      articles: [
        {
          date: "Jan 2036",
          subtitle: "Beyond 10 Years: IHKAAS Mall & Payment Integration",
          image: {
            src: "https://ihkaas.io/wp-content/uploads/2025/01/e19922cb-086e-4d9f-adcc-60a340bbee14.jpeg.webp",
            width: 224,
            height: 324,
          },
          title: "Beyond 10 Years: IHKAAS Mall & Payment Integration",
          listItems: [
            "IHKAAS Mall Realization",
            "Integrated Token Burning System",
            "IHKAAS as a Payment Standard",
          ],
          iconColor: "text-pink-600 border-pink-600 decoration-pink-600 font-black",
        },
      ],
    },
  ];

  const allContentCards = [
    {
      title: "Presale & Market Entry",
      content: [
        "• Conduct a presale with an initial duration of a few months, with the possibility of controlled extensions if necessary.",
        "• Complete Cyberscope verification to ensure contract security and transparency.",
        "• Lock €17,000 liquidity for 3 years, reinforcing long-term project stability.",
        "• IHKAAS trading goes live, allowing market participants to buy and sell the token.",
        "• Secure initial exchange listings on accessible small and mid-tier exchanges, improving liquidity and token accessibility.",
      ],
    },
    {
      title: "IHKAAS Ecosystem Enhancements",
      content: [
        "• IHKAAS Red: Implement burning statistics for transparency and introduce a voluntary burning feature.",
        "• IHKAAS White: Launch charity initiatives, including water projects, food and clothing aid, and other humanitarian efforts.",
        "• IHKAAS Blue: Introduce online sessions, educational lectures, and event payments to enhance community engagement.",
        "• IHKAAS Green: Prepare for future integration into restaurant and retail payments, either post-mall launch or earlier via strategic partnerships.",
        "• Deploy the NFT marketplace, expanding the IHKAAS ecosystem with digital assets and collectibles.",
      ],
    },
    {
      title: "Business & Community Growth",
      content: [
        "• Initiate marketing campaigns to promote IHKAAS Gold adoption, increasing project visibility.",
        "• Conduct five educational webinars on blockchain technology, cryptocurrency adoption, and IHKAAS ecosystem benefits.",
        "• Introduce user incentives for token burning, reinforcing a deflationary model and long-term token value.",
        "• List on larger mid-tier exchanges after initial launch, further strengthening liquidity and market adoption.",
      ],
    },
    {
      title: "Advanced Exchange Listings",
      content: [
        "• Strengthen liquidity pools to enhance trading stability and long-term sustainability.",
        "• Apply for listings on top-tier exchanges, including Binance, Coinbase, and Kraken, to expand IHKAAS's global market presence.",
     
      ],
    },
    {
      title: "Business & Token Adoption Growth",
      content: [
        "• Expand IHKAAS token adoption across various industries, increasing its real-world utility.",
        "• Implement strategic fee structures for transactions to support continuous token burning, ensuring long-term scarcity and value appreciation.",
        "• Secure 10+ business partnerships, integrating IHKAAS token as a payment option in realworld businesses.",
      ],
    },
    {
      title: "Education & Community Growth",
      content: [
        "• Organize tech conferences focusing on cryptocurrency adoption, blockchain innovation, and IHKAAS’s role in the digital economy.",

      ],
    },
    {
      title: "Year 5-7: Global Expansion & Mass Adoption",
      content: [
        "• Achieve widespread use of IHKAAS cryptocurrency, making it a recognized and trusted digital asset for transactions.",
        "• Form international partnerships with businesses, institutions, and financial platforms to promote IHKAAS as a preferred payment method globally.",
      ],
    },
    {
      title: "Metaverse & AI-Driven Commerce",
      content: [
        "• Develop AI-driven commerce solutions for the Virtual IHKAAS Mall, enabling automated and personalized shopping experiences.",

      ],
    },
    {
      title: "Year 7-10: Sustained Ecosystem Development",
      content: [
        "• Introduce new IHKAAS services based on market trends and user demands to ensure continuous innovation.",
        "• Maintain cutting-edge blockchain security and scalability, optimizing speed, efficiency, and user safety.",
      ],
    },
    {
      title: "Decentralized Community Governance",
      content: [
        "•  Implement a decentralized governance model, allowing the community to participate in decision-making and future development.",
        "• Realize the full vision of the IHKAAS ecosystem, integrating it seamlessly across both virtual and real-world applications",
      ],
    },
    {
      title: "Physical Business Integration",
      content: [
        "•  Expand IHKAAS White charity initiatives worldwide, addressing critical issues such as clean water access, food security, clothing, and humanitarian aid.",
        "• Implement IHKAAS Green in physical locations, enabling restaurants, shopping centers, and retail businesses to accept IHKAAS tokens as a standard payment method.",
      ],
    },
    {
      title: "IHKAAS Mall Realization",
      content: [
        "•Build the physical IHKAAS Mall upon successful roadmap completion.",
        "• Allow verified vendors to sell using IHKAAS tokens.",
        "• Integrate user reward programs based on spending.",
      ],
    },
    {
      title: "Integrated Token Burning System",
      content: [
        "• Every store (clothing, shoes, restaurants, food markets, electronics, etc.) in the physical and online mall will contribute to token burning via an IHKAAS fee on product sales.",

      ],
    },
    {
      title: "IHKAAS as a Payment Standard",
      content: [
        "• Establish IHKAAS cryptocurrency as a leading payment option across all stores.",
      ],
    },
  ];
  const defaultBoxes = timelineData.map((section) => {
    const article = section.articles?.[0];
    const firstItemTitle = article?.listItems?.[0] || "";
    const contentCard = allContentCards.find((card) => card.title === firstItemTitle);
    return {
      title: firstItemTitle,
      listItems: contentCard ? contentCard.content : [firstItemTitle],
    };
  });

  const handleSelectItem = (title) => {
    const fullContent = allContentCards.find((card) => card.title === title);
    timelineData.forEach((section, sectionIndex) => {
      section.articles.forEach((article) => {
        if (article.listItems.includes(title)) {
          setSelectedArticles((prev) => ({
            ...prev,
            [sectionIndex]: {
              title,
              listItems: fullContent ? fullContent.content : article.listItems,
            },
          }));
        }
      });
    });
  };

  const displayedBoxes = useMemo(() => {
    return defaultBoxes.map((box, index) =>
      selectedArticles[index] ? selectedArticles[index] : box
    );
  }, [selectedArticles]);

  return (
    <div className="w-full flex flex-col items-center px-4 sm:px-6 md:px-8">
      <div className="w-full max-w-6xl">
      <h1 className="text-left tabletSmall:!text-[24px] _title_n4amt_1 text-[24px] laptop:text-[24px] font-semibold leading-[150%] tracking-[0.56px] laptop:tracking-[1.12px] mt-[-8px] pt-[130px] mb-[24px] sm:mt-[-12px] sm:pt-[20px] sm:mb-[32px] md:mt-[-16px] md:pt-[116px] md:mb-[40px]">
                IHKAAS RoadMap
              </h1>

        <div className="w-full p-3 border border-[#e1c780] shadow-lg rounded-lg bg-[#121212] ">
          <div className="flex flex-col lg:flex-row gap-6 mt-[-25px]">
            {/* Desktop Layout */}
            <section className="hidden lg:flex flex-col mt-[-25px] w-full mt-[-50px]">
  {timelineData.map((item, index) => (
<><div key={item.year || index} className="flex w-full items-stretch  gap-0 -mr-[15px]  ">
  {/* Left column */}
  <div className="w-1/2 flex flex-col justify-center h-full ">
    <div className="rounded-xl p-4 mt-8 h-full flex flex-col justify-between ">
      <h2 className="text-orange-400 text-xl font-bold">{item.year}</h2>
      {item.articles.map((article) => (
        <TimelineArticle
          key={article.date}
          {...article}
          onSelectItem={handleSelectItem}
          selectedTitle={selectedArticles[index]?.title}
        />
      ))}
    </div>
  </div>

  {/* Right column */}
  <div className="w-1/2 h-full flex mt-[170px] xl:px-1, 2xl:px-10 -ml-[25px]">
    <div className="h-full w-full ">
      <ContentCard
        title={displayedBoxes[index]?.title}
        content={displayedBoxes[index]?.listItems}
      />
    </div>
  </div>
</div>
</>
  ))}
</section>


            {/* Mobile Layout */}
            <section className="flex flex-col lg:hidden">
              {timelineData.map((item, index) => (
                <div key={item.year || index} className="flex flex-col space-y-4 mb-8 ">
                  {item.articles.map((article) => (
                    <>
                      <TimelineArticle
                        key={article.date}
                        {...article}
                        onSelectItem={handleSelectItem}
                        selectedTitle={selectedArticles[index]?.title}
                      />
                      <ContentCard
                        title={displayedBoxes[index]?.title}
                        content={displayedBoxes[index]?.listItems}
                      />
                    </>
                  ))}
                </div>
              ))}
            </section>

          </div>
        </div>
      </div>

      {/* Custom CSS */}
      <style jsx>{`
        .custom-swiper .swiper-pagination-bullet {
          width: 14px;
          height: 14px;
          background-color: #e1c780;
          opacity: 0.6;
        }
        .custom-swiper .swiper-pagination-bullet-active {
          opacity: 1;
        }
      `}</style>
    </div>
  );
};

export default TimelineRoadmap;
